<template>
  <div class="dt-details2">
    <div class="dt-details--header">
      <div class="title" :title="contact && contact.contact_id">
        <span v-if="contact">{{ contact_name || $t('contact_name') }}</span>
      </div>
    </div>
    <div class="dt-details--body">
      <div class="dt-details--col">
        <div class="ut-flex">
          <div class="ut-text-secondary"> {{$t('last_modified')}} </div>
          <div style="margin-left: 8px">
            {{ contact.last_modified }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ContactFuncs } from '../../models/contacts.model';

export default {
  props: {
    contact: {
      type: Object,
      default: {}
    },
  },
  computed: {    
    contact_name: function() {
      return ContactFuncs.getName(this.contact)
    },
  },
};
</script>

<style>
</style>
